var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconFifteen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00390625,
    width: 66,
    height: 66,
    fill: "#9C9894"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1181 66.0039L19.8491 46.2038L19.1206 45.4156L17.125 38.3705L19.0082 40.2656L18.5225 39.1743V38.3255L18.7046 37.1736L18.7046 37.1736L19.6134 35.0718L18.4599 34.0412L22.4398 31.0256L23.7598 30.161L23.256 29.5547C23.256 29.5547 25.2594 28.3422 25.8058 27.4327C26.0267 27.0191 26.2542 27.3795 26.5223 27.8041C26.8436 28.3131 27.2233 28.9145 27.7198 28.3856C28.6304 27.4156 31.0198 27.3956 31.0198 27.3956L32.1748 26.5706L33.3298 25.7456L32.9998 24.0956L34.0148 23.2491L33.3305 19.4756L38.6098 15.5156L43.1448 19.1878L66.0005 39.1743V55.7303V66.0039H40.1181Z",
    fill: "#77726E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9709 48.8436C33.0237 48.8436 38.0311 43.8703 38.0311 37.7164C38.0311 36.0674 37.6691 34.5189 37.0256 33.1114C35.256 33.8756 34.0092 35.6451 34.0092 37.7164C34.0092 41.56 30.863 44.8217 26.9709 44.8217C23.0898 44.8217 19.9327 41.5975 19.9327 37.7164C19.9327 33.8353 23.0898 30.6781 26.9709 30.6781C27.3127 30.6781 27.6547 30.6982 27.9965 30.7585C28.8008 29.4716 29.8063 28.3454 31.0129 27.4204C29.7661 26.9378 28.3987 26.6562 26.9709 26.6562C20.8578 26.6562 15.8438 31.6032 15.8438 37.7164C15.8438 43.8296 20.8578 48.8436 26.9709 48.8436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3113 15.6362C36.8503 14.1751 34.4868 14.1584 33.0032 15.5832C31.5215 14.1584 29.157 14.1751 27.695 15.6362C26.2162 17.115 26.2162 19.5197 27.695 20.9984L33.0032 26.3735L38.3113 20.9984C39.7901 19.5196 39.7901 17.1149 38.3113 15.6362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0367 44.8217C38.6949 44.8217 38.3529 44.8016 38.0111 44.7413C37.2068 46.0283 36.2014 47.1544 34.9947 48.0794C36.2415 48.5621 37.609 48.8436 39.0367 48.8436C45.1499 48.8436 50.1639 43.8296 50.1639 37.7164C50.1639 31.6032 45.1499 26.6562 39.0367 26.6562C32.9654 26.6562 27.9766 31.5824 27.9766 37.7164C27.9766 39.3654 28.3385 40.9809 28.982 42.3884C30.7517 41.6243 31.9984 39.7877 31.9984 37.7164C31.9984 33.8728 35.1447 30.6781 39.0367 30.6781C42.9178 30.6781 46.075 33.8353 46.075 37.7164C46.075 41.5975 42.9178 44.8217 39.0367 44.8217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.32,
    height: 34.32,
    fill: "white",
    transform: "translate(15.8438 14.5273)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconFifteen);
export default __webpack_public_path__ + "static/media/shadow-icon-fifteen.77046a36f1c7f925ce21f887989ae862.svg";
export { ForwardRef as ReactComponent };